"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeSourceOrgData = exports.isSourceTypeAllowedInCurrentApp = exports.isSourceAllowedInCurrentApp = exports.getFilteredAppsBasedOnSourceType = exports.getBlockedSourceTypesFromApp = void 0;
var _common = require("../common");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getFilteredAppsBasedOnSourceType = exports.getFilteredAppsBasedOnSourceType = function getFilteredAppsBasedOnSourceType(sourceType) {
  // console.warn(sourceType)
  if (!sourceType) {
    return [];
  }
  switch (sourceType.toLowerCase()) {
    case "sapphire_spaces_-_beta":
      return [_common.APP_IDS.Artistic, _common.APP_IDS.Trends];
    case "network_streamer":
    case "genetec":
      return [_common.APP_IDS.Artistic, _common.APP_IDS.Trends, _common.APP_IDS.uConduct, _common.APP_IDS.Spaces];
    case "signage_player":
      return [_common.APP_IDS.Trends, _common.APP_IDS.uConduct, _common.APP_IDS.Spaces];
    case "emerald_signage":
      return [_common.APP_IDS.Trends, _common.APP_IDS.uConduct, _common.APP_IDS.Decisions, _common.APP_IDS.Spaces];
    case "web_browser_youtube":
      return [_common.APP_IDS.Trends, _common.APP_IDS.Spaces];
    case "hdmi_capture":
      return [_common.APP_IDS.Trends, _common.APP_IDS.uConduct, _common.APP_IDS.Spaces];
    case "tableau":
    case "epic":
    case "power_bi":
    case "servicenow":
    case "domo":
    case "excel":
    case "sap":
    case "grafana":
      return [_common.APP_IDS.Artistic, _common.APP_IDS.Spaces];
    case "splunk":
      return [_common.APP_IDS.Spaces, _common.APP_IDS.Switch, _common.APP_IDS.Artistic];
    // Allow widgets in Engage server player; do not block Artistic
    case "clock":
    case "world_clock":
    case "weather":
    case "timer":
    case "stopwatch":
    case "power_point":
      return [_common.APP_IDS.Spaces];
    default:
      return [_common.APP_IDS.Spaces];
  }
};
var getBlockedSourceTypesFromApp = exports.getBlockedSourceTypesFromApp = function getBlockedSourceTypesFromApp(appID) {
  if (!appID) {
    return [];
  }
  switch (appID) {
    case _common.APP_IDS.Trends:
      return ["Network_Streamer", "Genetec", "Milestone", "Signage_Player", "Web_Browser_YouTube", "Sapphire_Spaces_-_Beta", "HDMI_Capture", "Emerald_Signage"];
    case _common.APP_IDS.Artistic:
      // Do not block widget types globally; they will be filtered on Edge only
      // Also allow Power_Point in Engage server player
      return ["Network_Streamer", "Genetec", "Milestone", "Tableau", "Epic", "Power_BI", "Servicenow", "Grafana", "Splunk", "Domo", "SAP", "Sapphire_Spaces_-_Beta", "Excel"];
    default:
      return [];
  }
};
var isSourceTypeAllowedInCurrentApp = exports.isSourceTypeAllowedInCurrentApp = function isSourceTypeAllowedInCurrentApp(sourceType, appID) {
  if (!appID) {
    return true;
  }
  var blocked_apps = getFilteredAppsBasedOnSourceType(sourceType);
  return !blocked_apps.includes(appID);
};
var sanitizeSourceOrgData = exports.sanitizeSourceOrgData = function sanitizeSourceOrgData(sourceDef) {
  var blocked_apps = getFilteredAppsBasedOnSourceType(sourceDef.type.value);
  return _objectSpread(_objectSpread({}, sourceDef), {}, {
    orgData: _objectSpread(_objectSpread({}, sourceDef.orgData), {}, {
      appIDs: _objectSpread(_objectSpread({}, sourceDef.orgData.appIDs), {}, {
        appIDs: sourceDef.orgData.appIDs.appIDs.filter(function (app) {
          return !blocked_apps.includes(app.value);
        })
      })
    })
  });
};
var isSourceAllowedInCurrentApp = exports.isSourceAllowedInCurrentApp = function isSourceAllowedInCurrentApp(sourceDef, currentApp) {
  return isSourceTypeAllowedInCurrentApp(sourceDef.type.value, currentApp);
};